<template>
    <div>
    </div>
</template>

<script>
import Shepherd from "shepherd.js";
import config from "@/components/tutorial/showing";
import scrollIntoView from "scroll-into-view";
import steps from "./steps";
import AuthUser from "@/services/api/authUser";

export default {
  /**
   * e.g.
   * steps:
   * [
   * {
   *     title: "welcome!",
   *     text: "this is a tutorial",
   *     selector: ".big-button"
   * }
   * ]
   */
  props: ["forceShow", "whichSide"],
  data() {
    return {
      showing: false,
      steps: []
    };
  },
  created() {
    this.seenPages = {};
     this.tour = new Shepherd.Tour({
      defaultStepOptions: {
        showCancelLink: true,
        classes: "shepherd shepherd-welcome",
        scrollTo: true,
        scrollToHandler(elem) {
          let cushion = window.outerHeight / 3;
          scrollIntoView(elem, {
            align: {
              top: 0,
              topOffset: cushion
            }
          });
        }
      },
      classes: "shadow-md bg-purple-dark",
      useModalOverlay: true
    });

    this.$eventHub.$on('tutorial', (page) => {
      if (this.showPage(page)) {
        this.showTut(steps[page]);
      }
    });
  },
  computed: {
    side() {
      if (this.isMobile()) {
        return "top";
      } else {
        return this.whichSide || "right";
      }
    }
  },
  methods: {
    showPage() {
    // showPage(page) {
      // const seenPages = AuthUser.completed_tutorial_steps;
      // if (!seenPages.includes(page)) {
      //   AuthUser.save({completed_tutorial_steps: [page, ...seenPages]})
      //   return true;
      // }
      return false;
    },
    showTut(steps) {
      steps
        .map(step => {
          var side = this.side;
          if (step.side) {
            side = step.side;
          }
          return {
            title: step.title,
            text: step.text,
            attachTo: {
              element: step.selector,
              on: side
            },
            buttons: step.buttons || [
              {
                text: "Next",
                action: this.tour.next,
                classes: "shepherd-button"
              }
            ],
            tippyOptions: {
              boundary: "window"
            }
          };
        })
        .forEach((tourStep, index) => {
          this.tour.addStep(index, tourStep);
        });
      this.tour.on("complete", () => {
        this.setSeen();
      });
      this.tour.on("destroy", () => {
        this.setSeen();
      });
      this.tour.on("cancel", () => {
        this.setSeen();
      });
      this.tour.start();
      config.anyShowing = true;
    },
    isMobile() {
      return !!/Android|webOS|iPhone||iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    setSeen() {
      config.anyShowing = false;
      // Cookies.set(this.tutorialId(), "true", { expires: 1825 });
    },
    hasUserSeen() {
      let seen = Cookies.get(this.tutorialId()) !== undefined;
      return seen;
    },
    shouldShow() {
      if (config.anyShowing) {
        return false;
      }
      if (this.forceShow) {
        return true;
      } else {
        return this.show && !this.hasUserSeen();
      }
    },
  },
  watch: {
    $route() {
      this.tour.cancel();
      this.tour.steps = [];
    }
  }
};
</script>
<style lang="less">
@import "~shepherd.js/dist/css/shepherd-theme-default.css";
.shepherd-content {
  font-family: Roboto, sans-serif;
}
.shepherd-title {
  font-family: Roboto, sans-serif;
  font-weight: bold;
}
.shepherd-button {
  font-family: Roboto, sans-serif;
}
</style>
